import { MembersFormComponent } from './members-form/members-form.component';
import { NgModule } from '@angular/core';
import { MembersComponent } from './members.component';
import { Routes, RouterModule } from '@angular/router';
import { MembersDetailComponent } from './members-detail/members-detail.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:MembersComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
  {path:'new',component:MembersFormComponent,canActivate:[RoleGuard],data:{roles: ["admin",'manager','user']}},
  {path:'edit',component:MembersFormComponent,canActivate:[RoleGuard],data:{roles: ["admin",'userClube','manager','user']}},
  {path:'detail',component:MembersDetailComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}}
]

// o Administrador Khuzela faz CRUD
// o Utilizador Khuzela  só Lê  e Actualiza
// o Manager do Clube faz CRUD
// o Utilizador do Clube só Lê e Actualiza

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class MembersRoutingModule { }
